import moment from "moment/moment";
import { useEffect, useState } from "react";
import { methodPost } from "../../helper";
import info from "../../data/formulaires.json";

export default function ModalCreateLien({ setShowModal, refreshLiens }) {
  const [newLien, setNewLien] = useState({
    date: moment().format("YYYY-MM-DD HH:mm"),
    formType: 0,
  });

  async function handleUploadNewLien() {
    await methodPost("createLink.php", { ...newLien });

    setNewLien({
      date: moment().format("YYYY-MM-DD HH:mm"),
      formType: 0,
    });
    setShowModal(false);
    refreshLiens();
  }

  return (
    <div className="bg-black top-0 bottom-0 left-0 right-0 absolute bg-opacity-60 w-screen h-screen">
      <div className="flex flex-col max-w-5xl rounded-xl p-8 mx-auto mt-10 bg-palette-grey-orange">
        <div className="flex w-full justify-between items-center">
          <h1>Création du lien de formulaire</h1>
          <div onClick={() => setShowModal(false)} className="hover:bg-palette-green hover:bg-opacity-20 cursor-pointer rounded-full p-1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>
        <hr className="mb-10 mt-2" />
        <p className="mb-10 w-3/5">
          La création d'un lien pour une entreprise est valable tant que ce lien n'est pas supprimé. Après sa création, le lien peut être copié et envoyé.
        </p>
        <div className="w-2/5 mb-10 mx-auto space-y-10 flex flex-col">
          <div className="flex flex-col items-start space-y-1">
            <p className="font-bold">Société</p>
            <input
              onChange={(e) => setNewLien({ ...newLien, societe: e.target.value })}
              className="w-full bg-transparent text-md border border-palette-green text-gray-900 py-1 px-2 rounded-lg"
            />
          </div>
          <div className="flex flex-col items-start space-y-1">
            <p className="font-bold">Questionnaire</p>
            <select
              onChange={(e) => setNewLien({ ...newLien, formType: e.target.value })}
              className="w-full bg-transparent text-md border border-palette-green text-gray-900 py-1 px-2 rounded-lg"
            >
              {info.forms.map((e) => (
                <option key={"option_" + e.value} value={e.value}>
                  {e.title}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col items-start space-y-1">
            <p className="font-bold">Commentaire</p>
            <textarea
              onChange={(e) => setNewLien({ ...newLien, commentaire: e.target.value })}
              className="w-full bg-transparent text-md border border-palette-green text-gray-900 py-1 px-2 rounded-lg"
            />
          </div>
          <button onClick={() => handleUploadNewLien()} className="font-bold text-white bg-palette-green rounded-lg px-5 py-1.5">
            Créer lien
          </button>
        </div>
      </div>
    </div>
  );
}
